import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-view-reporteemployee',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, RouterModule],
  templateUrl: './view-reporteemployee.component.html',
  styleUrl: './view-reporteemployee.component.scss'
})
export class ViewReporteemployeeComponent {
@Input() InputData: any;
constructor(
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
       
  }

  close() {
    this.activeModal.close();
  }

  
}
